import request from "@/router/axios";

//flowableDoingPage
export const flowableDoingPage = (current, size, params) => {
  return request({
    url: '/api/blade-loanLending/loanLending/flowable-doing-page',
    method: 'post',
    data: {
      ...params,
      current,
      size,
    }
  })
}

export const haveBeenFundsPage = (current, size, params) => {
  return request({
    url: '/api/blade-loanLending/loanLending/haveBeenFunds',
    method: 'post',
    data: {
      ...params,
      current,
      size,
    }
  })
}

// findStructAuditDetail
export const findStructAuditDetail = (id, taskId) => {
  return request({
    url: `/api/blade-loanLending/loanLending/find-struct-audit-detail/${id}`,
    method: "get",
    params: {
      taskId,
    },
  });
};


//export
export const exportLoanLending = () => {
  return request({
    url: `/api/blade-loanLending/loanLending/export`,
    method: "get",
  });
};
